import collapse from 'edge/platform/widgets/accordion/collapse/directives/collapse';
import 'edge/platform/widgets/accordion/transition/module';

export default angular.module('edge.platform.widgets.ui.bootstrap.collapse', ['edge.platform.widgets.ui.bootstrap.transition']).directive('gwPlCollapse', collapse);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/accordion/collapse/module.js
// module id = 1085
// module chunks = 0